<div class="color-palette">
  <textarea
    name="color-palette"
    id="color-palette"
    rows="10"
    #colorTextarea
    (blur)="textareaBlur()"
    (focus)="textareaFocus()"
    [value]="textareaValue"
  >
  </textarea>

  @if (colors.length > 0 && !textareaFocused) {
    <div class="colors-holder" (click)="textareaFocus()">
      @for (color of colors; track color; let i = $index) {
        <div
          class="color"
          [style.background-color]="color"
          [class.wrong]="wrongColors.includes(i)"
        >
          <span>{{ color }}</span>
          @if (wrongColors.includes(i)) {
            <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
          }
        </div>
      }
    </div>
  }
</div>
